import { ReactNode } from "react"
import PuzzleScreen from "@/components/puzzle/PuzzleScreen"
import { usePage } from "@inertiajs/react"
import { PuzzleShowProps } from "@/types/types"
import AppLayout from "@/layouts/AppLayout"
import ShareModal from "@/modals/ShareModal"
import { PuzzleProvider } from "@/hooks/usePuzzle"

const PuzzlesShowPage = () => {
  const { puzzle, isOwner } = usePage<PuzzleShowProps>().props

  return (
    <PuzzleProvider puzzle={puzzle}>
      <PuzzleScreen isOwner={isOwner} />
      {isOwner && (
        <ShareModal
          title="Share puzzle"
          url={`https://chessdrop.com/puzzles/${puzzle.id}`}
          type="puzzle"
        />
      )}
    </PuzzleProvider>
  )
}

export default PuzzlesShowPage

PuzzlesShowPage.layout = (page: ReactNode) => (
  <AppLayout hideTabs hideBanners>
    {page}
  </AppLayout>
)
